import { css } from "@emotion/react";

import { SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const macroListGridStyles = css({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(360px, 1fr))",
  gap: withVar(SpacingToken.Spacing4),
});
